import React from 'react';
import { AgGridColumn } from 'ag-grid-react';
import { useHistory } from 'react-router-dom';
import Grid from '../../components/Grids/Grid';
import { useGetAllContractTypesQuery } from '../../services/accounting/accounting.service';
import DatacorLogoSpinner from '../../components/DatacorLogoSpinner/DatacorLogoSpinner';
import { GridOptions } from '../../components/Grids/grid.constants';

const ContractTypeGrid = () => {
    const history = useHistory();
    const { data: contractTypeList, isLoading } = useGetAllContractTypesQuery();

    const redirectToForm = (row: any) => {
        if (row.id) {
            history.push(`/accounting/contractType/${row.id}`);
        } else {
            history.push('/accounting/contractType/new');
        }
    };

    return isLoading ? (
        <DatacorLogoSpinner />
    ) : (
        <Grid
            rowData={contractTypeList}
            gridClass="full-width-grid"
            displayToolbar={true}
            displayCreateNewButton={true}
            onCreateNew={redirectToForm}
            onRowClicked={({ data }) => redirectToForm(data)}
            defaultColDef={GridOptions.sortFilterAndWrapColumns}>
            <AgGridColumn
                minWidth={100}
                field="sortOrder"
                headerName="Sort Order"
            />
            <AgGridColumn minWidth={150} field="code" headerName="Code" />
            <AgGridColumn
                minWidth={250}
                field="description"
                headerName="Description"
            />
        </Grid>
    );
};

export default ContractTypeGrid;
